document.addEventListener('DOMContentLoaded', () => {
  // The rating is server-rendered, so it already exists at this point — no need to
  // wait for the Loox widget to inject it.
  const ratingDiv = document.querySelector('#product-rating [data-product-rating]');
  if (!ratingDiv) return;

  ratingDiv.style.cursor = 'pointer';
  ratingDiv.onclick = function () {
    const target = document.getElementById('looxReviewsFrame');
    if (target) {
      const offset = 120;
      const topPos = target.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: topPos, behavior: 'smooth' });
    }
  };
});
